import React from "react";
import { Container, Typography, Box, Divider, Button, Grid } from "@mui/material";
import "./Steps.css";
import { ArrowDownIcon } from "../../common/icons";
import { useSelector } from "react-redux";
import { t } from "../../utils/i18n";
import ButtonSys from "../../common/ButtonSys";
const Steps = () => {
  const lang = useSelector((state) => state.i18n.lang);
  const stepsState = useSelector((state) => state.productData.steps);
  const steps =
    Array.isArray(stepsState.data) && stepsState.data.length > 0
      ? stepsState.data.map((s, i) => ({
          number: s.number,
          label: lang == "ar" ? s.step_title_ar : s.step_title,
          description: lang == "ar" ? s.description_ar : s.description,
          icon: s.image,
          step_number: s.step_number
        }))
      : [];

  if (!Array.isArray(steps) || steps.length === 0) {
    return null; 
  }


  return (
    <Box className="steps" mb={0} pb={4}>
      <Box sx={{ px: "0 !important", width: "90%", mx: "auto" }}>
        <Typography
          variant="h1"
          gutterBottom
          sx={{
            color: (theme) => theme.palette.text.main,
            mb: 4,
          }}
        >
          <Typography
            variant="h1"
            fontWeight={100}
            lineHeight={1}
            mb={"0 !important"}
          >
            {t(lang, "steps.getting_started")}
          </Typography>
          {t(lang, "steps.launch")}
        </Typography>

        <Grid container columnGap={6} rowGap={4}>
        {steps.map((step, index) => (
          <Grid item xs={12} sm={12} md={6} sx={{ width: "47%" }} key={index}>
            <Box
              sx={{
                backgroundColor: (theme) => theme.palette.background.steps,
                borderRadius: 8,
                padding: "20px",
                pr: lang === "ar" ? 6 : 20,
                pl: lang === "ar" ? 20 : 6,
                pb: 5,
                height: "100%",
                border: `1px solid ${(theme) =>
                  theme.palette.background.stepsBorder}`,
                position: "relative",
                overflow: "hidden",
                transition: "background-color 0.3s ease",
                "&:hover": {
                  backgroundColor: "#e5aeb4",
                },
              }}
            >
            <Box sx={{ mb: 2 }}>
              <Typography
                variant="h6"
                fontWeight={500}
                sx={{
                  textTransform: "uppercase",
                  mb: -1,
                  marginRight: "8px",
                  letterSpacing: 2,
                }}
              >
                {`${t(lang, "steps.step")} ${step.step_number}`}
              </Typography>
              <Typography
                variant="h3"
                fontWeight={600}
                sx={{
                  pb: 1,
                  fontSize: "2rem",
                }}
              >
                {step.label}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={`https://dolftech.com/storage/steps/${step.icon}`}
                style={{
                  transform: lang === "ar" ? "rotateY(-180deg)" : "none",
                }}
              />

              <Typography
                variant="h5"
                fontWeight={300}
                sx={{
                  lineHeight: 1.5,
                  mr: lang === "ar" ? 1 : 0,
                  ml: lang === "ar" ? 0 : 1,
                }}
                dangerouslySetInnerHTML={{ __html: step.description }}
              />
            </Box>
           </Box>
            </Grid>
          ))}
        </Grid>
        {/* <ButtonSys
          onClick={() => {
            const el = document.getElementById("pricing");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
          }}
          text={t(lang, "steps.startednow")}
        /> */}
      </Box>
    </Box>
  );
};

export default Steps;
